import {dicInvoiceType} from '../util/dicList'
import {rule} from '../util/validateRules'

export const optionPayOffline = {
	submitBtn: true,
	submitText: '立即提交',
	emptyBtn: false,
	labelWidth: '25%',
	column: [
		//transNo, payMoney, payAccountNo
		{
			label: '流水号',
			prop: 'transNo',
			span: 24,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入流水号',
					trigger: 'blur',
				},
				{
					validator: rule.validatorAbcNum,
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '支付金额',
			prop: 'payMoney',
			type: 'number',
			span: 24,
			display: false,
			controls: false,
			precision: 2,
			rules: [
				{
					required: true,
					message: '请输入支付金额',
					trigger: 'blur',
				},
			],
		},

		// payAccountName
		// payName
		//payAccountNo
		// payBankName
		//三星需要添加以上数据
		{
			label: '付款账户名称',
			prop: 'payAccountName',
			span: 24,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入付款账户名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '付款人名称',
			prop: 'payName',
			span: 24,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入付款人名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '付款账号',
			prop: 'payAccountNo',
			span: 24,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入付款账号',
					trigger: 'blur',
				},
				{
					validator: rule.validatorAbcNum,
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '付款银行支行名称',
			prop: 'payBankName',
			span: 24,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入付款银行支行名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '转账时间',
			prop: 'transferTime',
			span: 24,
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			pickerOptions: {
				disabledDate: (time) => {
					return time.getTime() > Date.now()
				},
			},
			rules: [
				{
					required: true,
					message: '请输入转账时间',
					trigger: 'blur',
				},
			],
		},
		{
			label: '转账凭证',
			prop: 'certificate',
			span: 14,
			type: 'upload',
			accept: 'image/png, image/jpeg',
			dragFile: true,
			listType: 'picture-img',
			propsHttp: {
				res: 'data',
			},
			action: '/dist/distInsure/uploadFile',
			rules: [
				{
					required: true,
					message: '请上传转账凭证',
					trigger: 'blur',
				},
			],
		},
		{
			label: '示例',
			prop: 'example',
			value: 'images/yyzz_sl1.png',
			type: 'upload',
			listType: 'picture-img',
			span: 10,
			propsHttp: {
				res: 'data',
			},
			disabled: true,
		},
	],
}

export const optionRepeatEmployee = {
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	align: 'center',
	menu: false,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	search: false,
	columnBtn: false,
	refreshBtn: false,
	saveBtn: false,
	updateBtn: false,
	cancelBtn: false,
	column: [
		{
			label: '姓名',
			prop: 'empName',
		},
		{
			label: '身份证',
			prop: 'empIdNo',
		},
		{
			label: '被保企业',
			prop: 'unitName',
		},
		{
			label: '保障中保单号',
			prop: 'policyNo',
		},
		{
			label: '保险止期',
			prop: 'expiryDate',
		},
	],
}

export const optionEmployeeRepeat = {
	index: true,
	indexLabel: '序号',
	addBtn: false,
	editBtn: false,
	delBtn: false,
	refreshBtn: false,
	columnBtn: false,
	addRowBtn: false,
	cellBtn: false,
	saveBtn: false,
	border: true,
	stripe: true,
	align: 'center',
	menu: false,
	column: [
		{
			label: '姓名',
			prop: 'empName',
			width: 120,
		},
		{
			label: '身份证',
			prop: 'empIdNo',
		},
		{
			label: '保障中的保单号',
			prop: 'policyNo',
		},
		{
			label: '保障起期',
			prop: 'effectiveDate',
		},
		{
			label: '保障止期',
			prop: 'expiryDate',
		},
	],
}

//发票
export const invoiceFormOption = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: '150',
	column: [
		{
			label: '开票类型',
			prop: 'invoiceType',
			type: 'select',
			dicData: dicInvoiceType,
			disabled: false,
			rules: [
				{
					required: true,
					message: '请选择开票类型',
					trigger: 'change',
				},
			],
		},
		{
			label: '开票金额',
			prop: 'money',
			slot: true,
			disabled: true,
		},
		{
			label: '统一信用代码',
			prop: 'identification',
			placeholder: '请填写统一信用代码',
			disabled: false,
			rules: [
				{
					required: true,
					validator: rule.validatorCreditCode,
					trigger: 'blur',
				},
			],
			display: true,
		},
		{
			label: '身份证号',
			prop: 'identification',
			placeholder: '请填写身份证号',
			disabled: false,
			display: false,
		},
		{
			label: '发票抬头',
			prop: 'title',
			slot: true,
			disabled: true,
		},
	],
	group: [
		{
			display: false,
			arrow: false,
			column: [
				{
					label: '注册地址',
					prop: 'address',
					placeholder: '请填写税务登记详细地址',
				},
				{
					label: '注册电话',
					prop: 'phone',
					placeholder: '请填写税务登记联系电话',
				},
				{
					label: '开户银行',
					prop: 'bankName',
					placeholder: '请填写税务登记开户银行',
				},
				{
					label: '开户账号',
					prop: 'bankNo',
					placeholder: '请填写税务登记开户行账号',
				},
				{
					label: '收件人',
					prop: 'mailName',
					disabled: false,
					placeholder: '请填写收件人姓名',
				},
				{
					label: '手机号',
					prop: 'mailPhone',
					disabled: false,
					placeholder: '请填写收件人手机号',
					rules: [
						{
							validator: rule.validatorMobile,
							trigger: 'blur',
						},
					],
				},
				{
					label: '收件人地址',
					type: 'cascader',
					disabled: false,
					prop: 'mailAreaCodeArray',
					props: {
						label: 'areaName',
						value: 'areaCode',
					},
					dicData: [],
					// dicUrl: `/dist/area/list/3`,
					// dicMethod: 'get',
					filterable: true,
					showAllLevels: true,
				},
				{
					label: '详细地址',
					prop: 'mailAddress',
					disabled: false,
					placeholder: '请填写收件人详细地址',
				},
				{
					label: '纳税人资质证明',
					type: 'upload',
					prop: 'taxCertificate',
					listType: 'picture-img',
					action: '/dist/distInsure/uploadFile',
					dragFile: true,
					propsHttp: {
						res: 'data',
					},
				},
				{
					label: '截图示例',
					prop: 'example1',
					formslot: true,
				},
			],
		},
	],
}

export const downloadOption = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	menuAlign: 'center',
	gutter: 20,
	index: true,
	indexLabel: '序号',
	header: false,
	editBtn: false,
	delBtn: false,
	column: [
		{
			label: '标题',
			prop: 'filename',
		},
	],
}

export const downloadNewOption = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	menuAlign: 'center',
	gutter: 20,
	index: true,
	indexLabel: '序号',
	header: false,
	editBtn: false,
	delBtn: false,
	column: [
		{
			label: '标题',
			prop: 'label',
		},
	],
}
